// extracted by mini-css-extract-plugin
export default {"Oyster":"#C0C5C9","White":"#FFFFFF","Bluecheese":"#615CFF","cta":"G121845 G21ac08","isDisabled":"G3e7db9","isFullWidth":"G3e2f0d"};